import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useStProjectSource(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/source`, {revalidateOnFocus: false})
    return {
        stProjectSource: data,
        mutateStProjectSource: mutate,
        isLoadingStProjectSource: !error && !data,
        isErrorStProjectSource: error
    }
}